var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#3AB44A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8008 14.8004C14.8008 13.4749 15.8753 12.4004 17.2008 12.4004H22.7037C23.3402 12.4004 23.9507 12.6532 24.4008 13.1033L28.4978 17.2004C28.9479 17.6505 29.2008 18.2609 29.2008 18.8974V29.2004C29.2008 30.5259 28.1263 31.6004 26.8008 31.6004H17.2008C15.8753 31.6004 14.8008 30.5259 14.8008 29.2004V14.8004ZM17.2008 22.0004C17.2008 21.3376 17.738 20.8004 18.4008 20.8004H25.6008C26.2635 20.8004 26.8008 21.3376 26.8008 22.0004C26.8008 22.6631 26.2635 23.2004 25.6008 23.2004H18.4008C17.738 23.2004 17.2008 22.6631 17.2008 22.0004ZM18.4008 25.6004C17.738 25.6004 17.2008 26.1376 17.2008 26.8004C17.2008 27.4631 17.738 28.0004 18.4008 28.0004H25.6008C26.2635 28.0004 26.8008 27.4631 26.8008 26.8004C26.8008 26.1376 26.2635 25.6004 25.6008 25.6004H18.4008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentActive);
export default __webpack_public_path__ + "static/media/document-active.82da8047fac5acff7748d3700b537753.svg";
export { ForwardRef as ReactComponent };